import React, { useState } from "react";
import DemoComposer from "./DemoComposer";
import DemoKuliahComposer from "./DemoKuliahComposer";
import { DemoSpeakerAvatar } from "./DemoSpeakerSelect";

const DemoAdminTabs = ({ announcement, kuliah }) => {
  const [active, setActive] = useState("announcement");
  return (
    <div className="demo-admin-tabs">
      <div className="demo-admin-tablist" role="tablist" aria-label="Kandungan Admin demo">
        <button
          type="button"
          role="tab"
          aria-selected={active === "announcement"}
          aria-controls="demo-admin-announcement"
          onClick={() => setActive("announcement")}
        >
          Pengumuman
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={active === "kuliah"}
          aria-controls="demo-admin-kuliah"
          onClick={() => setActive("kuliah")}
        >
          Tambah Kuliah
        </button>
      </div>
      <section id="demo-admin-announcement" role="tabpanel" hidden={active !== "announcement"}>
        <DemoComposer onSubmit={announcement.onSubmit} disabled={announcement.disabled} />
        <button className="demo-reset" type="button" onClick={announcement.onReset}>
          Kosongkan makluman
        </button>
      </section>
      <section id="demo-admin-kuliah" role="tabpanel" hidden={active !== "kuliah"}>
        <DemoKuliahComposer onSubmit={kuliah.onSubmit} disabled={kuliah.disabled} />
        {kuliah.current && (
          <div className="demo-kuliah-summary" aria-label="Kuliah demo semasa">
            <DemoSpeakerAvatar speaker={{
              name: kuliah.current.speakerName,
              image: kuliah.current.speakerImage,
            }} />
            <div className="demo-kuliah-summary-copy">
              <strong>{kuliah.current.title}</strong>
              <span>{kuliah.current.speakerName}</span>
              <span>{kuliah.current.date} · {kuliah.current.startTime}</span>
            </div>
            <button className="demo-reset" type="button" onClick={kuliah.onClear}>
              Kosongkan kuliah
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default DemoAdminTabs;
